angular.module('rjmNg.services').factory 'chartFormatterService',[
  "$location"
  "metricDataTypes"
  "conversionConstants"
  "stringService"
  "app"
  ($location, metricDataTypes, conversionConstants, stringService, app) ->
    chartFormatterService = {}

    chartFormatterService.sanitize = _sanitize = (str) ->
        String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;")
            .replace(/\//g, "&#x2F;")

    # Get conversion constants from file
    secondsConversionConstants = conversionConstants.TIME_CONVERSIONS
    byteConversionConstants = conversionConstants.DIGITAL_SIZE_CONVERSIONS
    dataTypeConstants = metricDataTypes.DATA_TYPES

    # General Utilities

    ## Determines whether a chart is multi-series
    chartFormatterService.isMultiSeries = (chart) ->
      return chart.data.series.length > 1

    ## Get significant digits for use with labels and tooltips
    chartFormatterService.getSignificantDigits = (chart) ->
      return chart.digits

    # This gets the padding of the chart labels on the X Axis
    chartFormatterService.getXAxisLabelY = (chartStyle) ->
      if chartStyle is 'bar'
        return y = 4
      else
        return y = 20

    # Get the alignment style for a chart based on its style
    chartFormatterService.getXAxisLabelAlignment = (chartStyle) ->
      switch chartStyle
        when "bar" then return "right"
        when "column" then return "center"
        else return "center"

    # Get the interval of labels to be shown on the X Axis.
    chartFormatterService.getStep = (chartStyle, categories, chartWidth, numYAxes) ->
      yAxisWidth = 60
      minWidthForLabels = 250
      approxWidthOneChar = 6.6 # Includes some padding

      numYAxes ?= 1
      if chartStyle is 'bar'
        return 1

      if categories?
        if not chartWidth?
          if categories.length < 8
            return 1
          else
            return Math.ceil(categories.length / 5) + 2
        chartWidth = chartWidth - (numYAxes * yAxisWidth)
        if chartWidth < minWidthForLabels
          return categories.length + 1
        categoryMaxLength = Math.max (categories.map (el) -> if el? then el.length else 4)... # cant call null.length so f el is null maxLength should be 4 ('null'.length)
        approxLabelWidth = (categoryMaxLength) * approxWidthOneChar # Includes some padding
        step = Math.ceil(categories.length / (chartWidth / approxLabelWidth)) + 1

        return Math.max(step, 1)

    # Get the color for a particular string name
    chartFormatterService.getColorByString = (name) ->
      name = name ? ''
      colors = ["#608F9F","#E89545","#86A542","#E77660","#F5C13D","#996798","#79C7D3","#55627F","#62F97E","#D6C2D6","#939393","#F99BB6","#EAE39D","#AD7538","#7F3030","#54683A"]
      return colors[stringService.hashCode(name.replace /^\s+|\s+$/g, "") % colors.length]

    # Get useful things like min and max, which are used to scale the axes
    chartFormatterService.getMinMax = (series, stacked) ->
      seriesMin = 0
      seriesMax = 0
      all = []
      allNegative = []

      # Stacked series require some additional care.  We need to find the largest and most negative sums for an interval
      if stacked
        for row in series # Loop through each series
          for datum, key in row.data # Loop through each data point and hold on to the key
            # Build an array of positive values
            all[key] ?= 0
            all[key] += datum if datum > 0

            # Build an array of negative values
            allNegative[key] ?= 0
            allNegative[key] += datum if datum < 0
      else
        # The unstacked charts are much easier
        for row in series
          # concatenates all datapoints in one array
          all = all.concat row.data

          # We can even use the same list, since we're looking for the overall largest and most negative
          allNegative = all

      # Find the max and min values
      seriesMax = Math.max.apply @, all
      seriesMin = Math.min.apply @, allNegative

      # Return the result
      return {
        min: seriesMin
        max: seriesMax
      }

    # Whether the columns are stacked
    chartFormatterService.isStacked = (chart) ->
      switch chart.chartStyle
        when "STACKED_COLUMN_CHART" then return "normal"
        when "STACKED_AREA_CHART" then return "normal"
        else
          return null

    # Adds commas to the value and returns the value along with the prefix and suffix
    # If adjust is true then this function also applies any necessary multipliers based on the prefix/suffix
    # Range includes the min and max values of the chart series
    chartFormatterService.getPrefixValueSuffix = (chart, value, adjust, range, useNewFormatting = false) ->
      # Number(value) returns a 0 in some cases when NaN would be preferable,
      # and parseFloat(value) converts strings beginning with numbers to floats
      # even with alphanumeric characters.
      if (!isNaN parseFloat value) and (!isNaN Number value)
        value = parseFloat value

      if typeof value is "number"
        if adjust and chart.data?
          if useNewFormatting
            return @getFormattedValue(value, chart.data.prefix, chart.data.suffix, dataTypeConstants.nonMonetary, range, value, false, chart.data.decimals)
          value = @getValueAdjustedForPrefixAndSuffix(value, chart.data.prefix, chart.data.suffix, chart.data.decimals, range)
        value = @addCommas(value)

      return {
        prefix: chart.data?.prefix
        value: value
        suffix: chart.data?.suffix
      }

    chartFormatterService.getValueAdjustedForPrefixAndSuffix = (value, prefix, suffix, decimals, range) ->

      if value is null or value is ''
        return null

      # Number(value) returns a 0 in some cases when NaN would be preferable,
      # and parseFloat(value) converts strings beginning with numbers to floats
      # even with alphanumeric characters.
      if (!isNaN parseFloat value) and (!isNaN Number value)
        value = parseFloat value

      # If we still have a string, stop
      if typeof value is 'string'
        return value

      granularityThreshold = 0.1
      needMoreGranularity = false
      if range?
        singleValueRange = range.max is range.min
        #if the range of values is a single value then we need more granularity only if its less than the granularityThreshold
        if singleValueRange and Math.abs(range.max) < granularityThreshold
          needMoreGranularity = true
        #if the range of values is not a single value then we need more granularity if max-min is less than the granularityThreshold
        else if not singleValueRange and (range.max - range.min) < granularityThreshold
          needMoreGranularity = true

      #if its a float value and there is no suffix we need to adjust the number of decimals:
      #if the range of values is below the granularityThreshold then show 4 decimals
      #otherwise show 2 decimals
      if suffix is '' and value % 1 isnt 0
        return if not needMoreGranularity then value.toFixed(2) else value.toFixed(4)

      if prefix is '' and suffix is ''
        return value

      if prefix isnt '' #its a currency value
        return value.toFixed(decimals)

      # We may have to change the value based on the suffix as well
      return @getSuffixAdjustedValue(value, suffix)

    # Formatting scalars and y-Axis labels
    # This will eventually replace getValueAdjustedForDataType
    chartFormatterService.getFormattedValue = (value, prefix, suffix, dataType, range, median, fullValue = false, decimalPlaces) ->
      if value is null
        return "<em>null</em>"
      else if value is ''
        return ''

      if not @isNumeric(value)
        return value

      returnValue = value
      returnPrefix = prefix
      returnSuffix = suffix
      median ?= value
      localRange = range ? { max: value, min: value } # Don't use 'range' directly; objects are passed by reference
      knownDataTypes = (v for k,v of dataTypeConstants)
      if not dataType? or not (dataType in knownDataTypes) then dataType = dataTypeConstants.nonMonetary

      # Just pretend the dataType is percentage if the suffix is '%'
      if returnSuffix is '%' then dataType = dataTypeConstants.percentage

      [returnValue, returnPrefix, returnSuffix] = @dataTypeSpecificFormatting(dataType, returnValue, returnPrefix, returnSuffix, median)
      returnPrefix = _putClassOnPrefix(returnPrefix) # Put prefix class on prefix. Do the same thing for suffix below.

      # Put minus sign before any prefix for negative numbers
      if returnValue < 0 then returnValue = returnValue * -1; returnPrefix = '-' + returnPrefix

      # For very large/small values we just convert to scientific notation
      if not fullValue and (Math.abs(returnValue) >= Math.pow(10,21) or (Math.abs(returnValue) < Math.pow(10,-20) and returnValue isnt 0))
        returnValue = returnValue.toExponential(1)
        return returnPrefix + returnValue + _putClassOnSuffix(returnSuffix)

      siSymbol = ''
      if _shouldConvertSI(dataType, returnSuffix) and returnValue isnt 0 and not fullValue
        convertedValueAndSISymbol = _convertSI(returnValue)
        if convertedValueAndSISymbol.siSymbol isnt ''
          returnValue = convertedValueAndSISymbol.convertedValue
          siSymbol = convertedValueAndSISymbol.siSymbol

      if fullValue then returnValueCommasAdded = @fullValueFormatting(returnValue)
      else
        numDecimalPlaces = _getNumDecimalPlaces(value, returnValue, dataType, localRange, decimalPlaces)
        returnValueCommasAdded = @addCommas(parseFloat(returnValue).toFixed(numDecimalPlaces))

      if dataType is dataTypeConstants.seconds and returnSuffix is ' secs'
        return returnPrefix + returnValueCommasAdded + _putClassOnSuffix(' ' + siSymbol + 'secs')
      else
        return returnPrefix + returnValueCommasAdded + siSymbol + _putClassOnSuffix(returnSuffix)

    # Format an untruncated value
    chartFormatterService.fullValueFormatting = (value) ->
      returnValue = parseFloat(value)

      if returnValue % 1 is 0
        return @addCommas(returnValue)

      extraGranularity = if returnValue < 0.01 then true else false
      returnValue = if extraGranularity then returnValue.toFixed(4) else returnValue.toFixed(2)

      return @addCommas(returnValue)

    # Special formatting for each dataType
    chartFormatterService.dataTypeSpecificFormatting = (dataType, value, prefix, suffix, median) ->
      if dataType is dataTypeConstants.percentage then value *= 100
      else if dataType is dataTypeConstants.currency
        # We need to use Helvetica to display Thai bahts
        if prefix.trim() is '฿' or prefix.trim() is '&#3647;'
          prefix = '<span style="font-family: Helvetica">' + prefix + '</span>'
      else if dataType is dataTypeConstants.seconds
        adjustedValueAndSuffix = @getAdjustedValueSeconds(value, median)
        value = adjustedValueAndSuffix.value
        suffix = adjustedValueAndSuffix.suffix
      else if dataType is dataTypeConstants.bytes
        adjustedValueAndSuffix = @getAdjustedValueBytes(value, median)
        value = adjustedValueAndSuffix.value
        suffix = adjustedValueAndSuffix.suffix

      return [value, prefix, suffix]

    _putClassOnPrefix = (prefix) ->
      if prefix is ''
        return prefix
      else
        return '<span class="prefix">' + prefix + '</span>'

    _putClassOnSuffix = (suffix) ->
      if suffix is ''
        return suffix
      else
        return '<span class="suffix">' + suffix + '</span>'

    # Convenience function to determine whether or not SI conversion is appropriate
    _shouldConvertSI = (dataType, suffix) ->
      shouldConvertSI = false

      if dataType is dataTypeConstants.nonMonetary or
        dataType is dataTypeConstants.currency or
        dataType is dataTypeConstants.percentage or
        (dataType is dataTypeConstants.seconds and
          (suffix is ' secs' or suffix is ' years')) or
        (dataType is dataTypeConstants.bytes and
          (suffix is ' B' or suffix is ' TB'))
        shouldConvertSI = true

      return shouldConvertSI

    # Returns a converted value and its SI symbol for v large/small values
    _convertSI = (value) ->
      siSymbol = ''

      absValue = Math.abs(value)

      if absValue is 0 then return { siSymbol: '', convertedValue: value }

      if absValue >= Math.pow(10,18) then value /= Math.pow(10,18) ; siSymbol = "E"         # exa
      else if absValue >= Math.pow(10,15) then value /= Math.pow(10,15) ; siSymbol = "P"    # peta
      else if absValue >= Math.pow(10,12) then value /= Math.pow(10,12) ; siSymbol = "T"    # tera
      else if absValue >= Math.pow(10,9) then value /= Math.pow(10,9) ; siSymbol = "G"      # giga
      else if absValue >= Math.pow(10,6) then value /= Math.pow(10,6) ; siSymbol = "M"      # mega
      else if absValue >= Math.pow(10,3) then value /= Math.pow(10,3) ; siSymbol = "k"      # kilo
      else if absValue < Math.pow(10,-17) then value /= Math.pow(10,-18) ; siSymbol = "a"   # atto
      else if absValue < Math.pow(10,-14) then value /= Math.pow(10,-15) ; siSymbol = "f"   # femto
      else if absValue < Math.pow(10,-11) then value /= Math.pow(10,-12) ; siSymbol = "p"   # pico
      else if absValue < Math.pow(10,-8) then value /= Math.pow(10,-9) ; siSymbol = "n"     # nano
      else if absValue < Math.pow(10,-5) then value /= Math.pow(10,-6) ; siSymbol = "μ"     # micro
      else if absValue < Math.pow(10,-2) then value /= Math.pow(10,-3) ; siSymbol = "m"     # milli

      retVal =
        siSymbol: siSymbol
        convertedValue: value

    # Calculates the appropriate number of decimal places to display for a given value
    _getNumDecimalPlaces = (originalValue, convertedValue, dataType, range, desiredDecimalPlaces) ->
      spread = range.max - range.min
       # The original value may have been converted; multiply spread by the same factor
      if originalValue isnt 0 then spread *= convertedValue / originalValue else spread = 0
      if spread isnt 0
        spread = Math.abs(spread)
        if spread < .000000005 then return 10
        else if spread < .00000005 then return 9
        else if spread < .0000005 then return 8
        else if spread < .000005 then return 7
        else if spread < .00005 then return 6
        else if spread < .0005 then return 5
        else if spread < .005 then return 4
        else if spread < .05 then return 3
        else if spread < .5 then return 2
        else if spread < 5 then return 1

      # We can use optional desired number of decimal places instead of basing num decimal places on datatype
      if desiredDecimalPlaces?
        if Math.pow(10,3) > Math.abs(originalValue) >= Math.pow(10,-2)
          if convertedValue % 1 is 0 # Whole numbers have no decimal places displayed
            return 0
          else
            return desiredDecimalPlaces

      # Currencies and Percentages always get two decimal places, unless the value is really small
      if (dataType is dataTypeConstants.currency and Math.pow(10,3) > Math.abs(originalValue) >= Math.pow(10,-2)) or
        (dataType is dataTypeConstants.percentage and Math.pow(10,1) > Math.abs(originalValue) >= Math.pow(10,-4))
          if convertedValue < 0.1 and convertedValue isnt 0
            return 3
          return 2 # percentages and currencies always get 2 decimal places
      else # All other data types get one deimcal place, unless the value is really small
        if convertedValue < 0.1 and convertedValue isnt 0
          return 3
        if convertedValue % 1 is 0 # Whole numbers have no decimal places displayed
          return 0
        else
          return 1

    # Formats a display value from the raw value, prefix, suffix, data type, and median of the metric dataset
    chartFormatterService.getValueAdjustedForDataType = (value, prefix, suffix, dataType, range, median, truncate = false) ->
      if value is null then return "<em>null</em>"
      else if value is '' then return ''

      # copy parameter objects just so we don't accidentally mutate them
      formattedValue = value
      formattedSuffix = suffix
      localRange = range
      localMedian = median

      if (!isNaN parseFloat value) and (!isNaN Number value)
        formattedValue = parseFloat(value)

      localRange ?=
        min: formattedValue
        max: formattedValue
      if formattedSuffix is '%'
        formattedValue = (value * 100).toFixed(2)
      else
        switch dataType
          when dataTypeConstants.raw
            formattedValue = value
          when dataTypeConstants.nonMonetary
            formattedValue = @getAdjustedValueDecimalPlaces(formattedValue, localRange)
          when dataTypeConstants.percentage
            formattedValue = (formattedValue * 100).toFixed(2)
          when dataTypeConstants.currency
            formattedValue = @getAdjustedValueDecimalPlaces(formattedValue, localRange, 2)
          when dataTypeConstants.bytes
            adjustedValueAndSuffix = @getAdjustedValueBytes(formattedValue, localMedian) # adjust both the value and suffix when doing byte conversion
            formattedValue = (adjustedValueAndSuffix.value).toFixed(2)
            formattedSuffix = adjustedValueAndSuffix.suffix
          when dataTypeConstants.seconds
            adjustedValueAndSuffix = @getAdjustedValueSeconds(formattedValue, localMedian) # adjust both the value and suffix when doing seconds conversion
            formattedValue = (adjustedValueAndSuffix.value).toFixed(2)
            formattedSuffix = adjustedValueAndSuffix.suffix
          else
            formattedValue = value # no data type defined

      if truncate
        if formattedSuffix is '%' or dataType is dataTypeConstants.percentage
          formattedValue = value * 100.00
        else if dataType is dataTypeConstants.bytes or dataType is dataTypeConstants.seconds
          formattedValue = adjustedValueAndSuffix.value

        displayedValue = @formatTruncated(formattedValue, prefix, formattedSuffix, localRange, dataType)
      else if dataType is dataTypeConstants.raw
        displayedValue = formattedValue
      else
        displayedValue = prefix + @addCommas(formattedValue) + formattedSuffix

      return _sanitize displayedValue

    chartFormatterService.formatTruncated = (value, prefix, suffix, range, dataType) ->
      spread = range.max - range.min
      absValue = Math.abs(value)

      if dataType is "value (percentage)" then spread *= 100
      else if dataType is "value (seconds)"
        spread = switch suffix
          when " mins" then spread/secondsConversionConstants.secondsPerMin
          when " hours" then spread/secondsConversionConstants.secondsPerHour
          when " days" then spread/secondsConversionConstants.secondsPerDay
          when " months" then spread/secondsConversionConstants.secondsPerMonth
          when " years" then spread/secondsConversionConstants.secondsPerYear
          else spread
        decimalPlaces = @getDecimalPlacesForSpread(spread,1)
      else if dataType is "value (bytes)"
        spread = switch suffix
          when " KB" then spread/byteConversionConstants.bytesPerKilobyte
          when " MB" then spread/byteConversionConstants.bytesPerMegabyte
          when " GB" then spread/byteConversionConstants.bytesPerGigabyte
          when " TB" then spread/byteConversionConstants.bytesPerTerabyte
          else spread
        decimalPlaces = @getDecimalPlacesForSpread(spread,1)

      if dataType isnt "value (bytes)" and dataType isnt "value (seconds)"
        # Adjust value and add symbol for big numbers
        if absValue >= Math.pow(10,18) then value /= Math.pow(10,18) ; siSymbol = "E"; ; decimalPlaces = @getDecimalPlacesForSpread(spread, Math.pow(10,18))
        else if absValue >= Math.pow(10,15) then value /= Math.pow(10,15) ; siSymbol = "P" ; decimalPlaces = @getDecimalPlacesForSpread(spread, Math.pow(10,15))
        else if absValue >= Math.pow(10,12) then value /= Math.pow(10,12) ; siSymbol = "T" ; decimalPlaces = @getDecimalPlacesForSpread(spread, Math.pow(10,12))
        else if absValue >= Math.pow(10,9) then value /= Math.pow(10,9) ; siSymbol = "G" ; decimalPlaces = @getDecimalPlacesForSpread(spread, Math.pow(10,9))
        else if absValue >= Math.pow(10,6) then value /= Math.pow(10,6) ; siSymbol = "M" ; decimalPlaces = @getDecimalPlacesForSpread(spread, Math.pow(10,6))
        else if absValue >= 1000 then value /= 1000 ; siSymbol = "k" ; decimalPlaces = @getDecimalPlacesForSpread(spread, 1000)
        else decimalPlaces = @getDecimalPlacesForSpread(spread,1)

      return prefix + @addCommas(parseFloat(value).toFixed(decimalPlaces)) + (siSymbol ? '') + suffix

    chartFormatterService.getDecimalPlacesForSpread = (spread, multiplier) ->
      if spread < multiplier * 0.02 then return 3
      else if spread < multiplier * 0.2 then return 2
      else if spread < multiplier * 2 then return 1
      else return 0

    # Determines if the tooltip should be shared or not.  Check to see if the chart is large enough for the shared tooltip
    # based on how many visible data points there are for a given interval
    chartFormatterService.getSharedTooltip = (categories, series, chartStyle, highchartStyle, point, visibleSeries, height, min) ->
      totalViewablePoints = 0

      # If we have negative values then we want to show zero values in the tooltip
      showZeroes = min < 0

      # Adjust these to tweak the tooltip behavior
      heightOffset  = 100
      heightPerSeries = 33

      # Formula used to calculate our maximum number of viewable datapoints for this interval's chart
      # This allows us to change behavior if the user resizes the page
      maxViewablePoints = ((height - heightOffset ) / heightPerSeries ).toFixed(0)

      if categories? and point? and series?
        if !point.points?
          xAxisKey = point.key
          intervalKey = null

          # Find the key for the interval we're hovering over
          for key,value of categories
            if value is xAxisKey
              intervalKey = key
              break

          # Did we find it?
          if intervalKey?
            # Count non zero and non null items to see which tooltip we shold use
            for key, value of series
              if (value.data[intervalKey] != 0 or showZeroes) and value.data[intervalKey]? and visibleSeries[key]
                totalViewablePoints += 1
      else
        return false

      if totalViewablePoints >= maxViewablePoints or chartStyle is 'PIE_CHART' or highchartStyle is 'bar'
        return false
      else
        return true

    # returns a series that has its values adjusted after applying possible multipliers
    chartFormatterService.getFormattedSeries = (chart, range) ->
      newseries = []
      for series in chart.data.series then do (series) =>
        newdata = []
        for value in series.data then do (value) =>
          formattedValue = @getValueAdjustedForPrefixAndSuffix(value, chart.data.prefix, chart.data.suffix, chart.data.decimals, range)
          #highcharts is expecting a float value here
          newdata.push if formattedValue? then parseFloat(formattedValue) else null

        newseries.push
          name: series.name
          data: newdata
      return newseries;

    # returns a the json value needed by jquery.dataTables to properly sort the column
    chartFormatterService.getSortingJson = (sortType) ->
      sortType = sortType.toLowerCase() # Let's not bring case into this
      sortingJson = switch
        when sortType is "date"   then { sType : "rjmdate" }
        when sortType is "number"   then { sType : "strippedNumerics" } # This should account for currency, percentages, and values with commas
        when sortType is "period"   then { sType : "strippedNumerics" } # special case for cohort charts, allow sorting of values like Month 1, Month 2 etc.
        else 'null' # a value of null just lets jquery.DataTables auto detect the sorting method.  It can do numeric, date, string, and html on its own

      return sortingJson

    # If the name is too long for tooltips, it shortens it to a more appropriate length and lets the user know it was shortened
    chartFormatterService.getDisplayName = (name, chartWidth) ->

      # Approximates how many pixels we need to allow an additional character into the series title
      # This includes some overhead pixels for the chart and tooltip itself
      # I tried a bunch of values, and this one seemed to work best with all chart widths
      pixelsPerCharacter = 18

      # We check to see how many characters who should allow for a chart this wide
      nameMaxLength = Math.round(chartWidth / pixelsPerCharacter)

      # If the series title exceeds this lenght, truncate it
      if name.length > nameMaxLength
        name = name.toString().substring(0,nameMaxLength) + "..."

      return name

    # Gets interval data based on what we're hovering over
    chartFormatterService.getCategoryDataPoints = (chart, category, min, visibleSeries) ->
      points = []
      total = 0

      showZeroes = min < 0
      colors = chart.series[0].colorValues

      if chart? and category?
        xAxisKey = category.key
        intervalKey = null

        # Find the key for the interval we're hovering over
        for key,value of chart.data?.categories
          if value is xAxisKey
            intervalKey = key
            break

        # Did we find the key?
        if intervalKey?
          # Count non zero and non null and non empty string  items to see which tooltip we shold use
          for key, value of chart.data.series
            if ( (value.data[intervalKey] != 0 or showZeroes) and value.data[intervalKey]? and visibleSeries[key] and value.data[intervalKey] != "") or chart.data.series.length is 1
              point = { y:value.data[intervalKey], name:value.name, color: "#" + colors[key%colors.length] }

              # Number(value) returns a 0 in some cases when NaN would be preferable,
              # and parseFloat(value) converts strings beginning with numbers to floats
              # even with alphanumeric characters.
              if (!isNaN parseFloat point.y) and (!isNaN Number point.y)
                point.y = parseFloat point.y
              total += point.y
              points.push(point)

        for i of points
          points[i].percentage = (points[i].y / total) * 100

      # Sort LINE_CHARTS datapoints before returning
      if chart.chartStyle is 'LINE_CHART'
        points = points.sort (a,b) ->
          return if a.y > b.y then -1 else 1
      return points

    # If we sort by the series names here we know the colors will match up
    chartFormatterService.sortSeriesByName = (series) ->
      maxSeriesLength = 100
      # Exempt ourselves from giant sorts with greater than 100 series
      if series.length <= maxSeriesLength
        series = series.sort (a,b) ->
          x = a.name
          y = b.name

          # If these are numbers, sort them as numbers not strings
          if !isNaN(x) and !isNaN(y)
            x = (Number) x
            y = (Number) y

          # Sort nulls as zero
          x ?= 0
          y ?= 0

          # Sort these cases as zeroes
          if x is "[NULL]" then x = 0
          if y is "[NULL]" then y = 0

          if x is "[blank]" then x = 0
          if y is "[blank]" then y = 0

          # If one of the values is a string, convert both to strings.  This prevents comparing numerics and strings
          if typeof x is "string" or typeof y is "string"
            x = (String) x
            y = (String) y

          return if x > y then 1 else -1
      return series

    # We don't currently have a great way to determine whether this is a cohort or not on the client, but
    # for now cohorts always have "Period" for their categoryHeader instead of "Value"
    chartFormatterService.isCohort = (chart) ->
      cohort = false
      if chart.data.categoryHeader is "Period" then cohort = true

      return cohort

    # Time values and percentage require special formatting
    chartFormatterService.getSuffixAdjustedValue = (value, suffix) ->

      unless value?
        return value

      if (!isNaN parseFloat value) and (!isNaN Number value)
        value = parseFloat(value)

      value = switch suffix
        when "%" then (value * 100).toFixed(2)
        #Convert Seconds to minutes
        when " mins" then (value / 60).toFixed(2)
        #Convert Seconds to hours
        when " hours" then (value / 3600).toFixed(2)
        #Convert Seconds to days
        when " days" then (value / 86400).toFixed(2)
        #Convert Seconds to weeks
        when " weeks" then (value / 604800).toFixed(2)
        #Convert Seconds to months
        when " months" then (value / 2629800).toFixed(2)
        #Convert Seconds to quarters
        when " quarters" then (value / 7905585).toFixed(2)
        #Convert Seconds to years
        when " years" then (value / 31556952).toFixed(2)
        #Use 2 places when we have anything other than an empty string
        else
          # If we pass in something, use two.  Empty suffixes get three.
          if !!suffix then value.toFixed(2) else value.toFixed(3)

      return value

    # Converts a value in bytes to the most appropriate unit: B, KB, MB, GB, or TB, and appends that suffix
    chartFormatterService.getAdjustedValueBytes = (valueInBytes, median) ->
      if (!isNaN parseFloat valueInBytes) and (!isNaN Number valueInBytes)
        valueInBytes = parseFloat(valueInBytes)

      if median is null or isNaN median
        median = valueInBytes

      absMedian = Math.abs(median)

      kilobyteThreshold = byteConversionConstants.bytesPerKilobyte * 10 # display KBs if absMedian > 10 KBs
      megabyteThreshold = byteConversionConstants.bytesPerMegabyte * 10 # display MBs if absMedian > 10 MBs
      gigabyteThreshold = byteConversionConstants.bytesPerGigabyte * 10 # display GBs if absMedian > 10 GBs
      terabyteThreshold = byteConversionConstants.bytesPerTerabyte * 10 # display TBs if absMedian > 10 TBs

      if absMedian > terabyteThreshold then adjustedValue = valueInBytes / byteConversionConstants.bytesPerTerabyte ; adjustedSuffix = ' TB'
      else if absMedian > gigabyteThreshold then adjustedValue = valueInBytes / byteConversionConstants.bytesPerGigabyte ; adjustedSuffix = ' GB'
      else if absMedian > megabyteThreshold then adjustedValue = valueInBytes / byteConversionConstants.bytesPerMegabyte ; adjustedSuffix = ' MB'
      else if absMedian > kilobyteThreshold then adjustedValue = valueInBytes / byteConversionConstants.bytesPerKilobyte ; adjustedSuffix = ' KB'
      else adjustedValue = valueInBytes ; adjustedSuffix = ' B'

      adjustedValueAndSuffix =
        value: adjustedValue
        suffix: adjustedSuffix

      return adjustedValueAndSuffix

    # Converts a value in seconds to the most appropriate unit: secs, mins, hours, days,
    # weeks, months, quarters, or years, and appends that suffix
    chartFormatterService.getAdjustedValueSeconds = (valueInSeconds, median) ->
      if (!isNaN parseFloat valueInSeconds) and (!isNaN Number valueInSeconds)
        valueInSeconds = parseFloat(valueInSeconds)

      if median is null or isNaN median
        median = valueInSeconds

      absMedian = Math.abs(median)

      minutesThreshold = 300 # display minutes if absMedian > 300 seconds
      hoursThreshold = 360 * secondsConversionConstants.secondsPerMin # display hours if absMedian > 360 minutes
      daysThreshold = 72 * secondsConversionConstants.secondsPerHour # display days if absMedian > 72 hours
      monthsThreshold = 90 * secondsConversionConstants.secondsPerDay # display months if absMedian > 90 days
      yearsThreshold = 36 * secondsConversionConstants.secondsPerMonth # display years if absMedian > 36 months

      if absMedian > yearsThreshold then adjustedValue = valueInSeconds / secondsConversionConstants.secondsPerYear ; adjustedSuffix = ' years'
      else if absMedian > monthsThreshold then adjustedValue = valueInSeconds / secondsConversionConstants.secondsPerMonth ; adjustedSuffix = ' months'
      else if absMedian > daysThreshold then adjustedValue = valueInSeconds / secondsConversionConstants.secondsPerDay ; adjustedSuffix = ' days'
      else if absMedian > hoursThreshold then adjustedValue = valueInSeconds / secondsConversionConstants.secondsPerHour; adjustedSuffix = ' hours'
      else if absMedian > minutesThreshold then adjustedValue = valueInSeconds / secondsConversionConstants.secondsPerMin ; adjustedSuffix = ' mins'
      else adjustedValue = valueInSeconds ; adjustedSuffix = ' secs'

      adjustedValueAndSuffix =
        value: adjustedValue
        suffix: adjustedSuffix

      return adjustedValueAndSuffix

    # Modifies a value to have the appropriate number of decimal places based on data type and the range of numbers in its series
    chartFormatterService.getAdjustedValueDecimalPlaces = (value, range, defaultNumDecimalPlaces) ->
      if value is null or value is ''
        return null

      if not @isNumeric(value)
        return value

      defaultNumDecimalPlaces ?= 0

      # Number(value) returns a 0 in some cases when NaN would be preferable,
      # and parseFloat(value) converts strings beginning with numbers to floats
      # even with alphanumeric characters.
      if (!isNaN parseFloat value) and (!isNaN Number value)
        value = parseFloat value

      granularityThreshold = 0.1
      needMoreGranularity = false
      if range?
        singleValueRange = range.max is range.min
        #if the range of values is a single value then we need more granularity only if its less than the granularityThreshold
        if singleValueRange and range.max isnt 0 and Math.abs(range.max) < granularityThreshold
          needMoreGranularity = true
        #if the range of values is not a single value then we need more granularity if max-min is less than the granularityThreshold
        else if not singleValueRange and (range.max - range.min) < granularityThreshold
          needMoreGranularity = true

      #if the range of values is below the granularityThreshold then show 4 decimals
      #otherwise show 2 decimals
      if value % 1 isnt 0
        return if not needMoreGranularity then value.toFixed(2) else value.toFixed(4)

      # othwerwise return value with any default that has been set (unless granularity flag set)
      return if not needMoreGranularity then value.toFixed(defaultNumDecimalPlaces) else value.toFixed(4)

    chartFormatterService.isNumeric = (value) ->
      isEmptyString = (typeof value) is "string" and value.trim().length == 0
      return not isNaN(+value) and isFinite(value) and not isEmptyString

    # formats numbers with thousands place commas
    chartFormatterService.addCommas = (value) ->
      if not @isNumeric(value)
        return value

      splitStr = "#{value}".split "."
      splitStr[0] = splitStr[0].replace /\B(?=(\d{3})+(?!\d))/g, ","
      return splitStr.join(".")

    # Returns the categories for a chart object
    chartFormatterService.getCategories = (chart) ->
      return chart.data?.categories

    # This is to cover the cases where we have an array like [null, 3, null]
    # Or the case where we have [null, null, 3]. Otherwise they wouldn't show up in line charts
    chartFormatterService.setMarkers = (series, chartStyle) ->
      if chartStyle is 'line' and series.data?
        for point, index in series.data
          if not series.data[index-1]? and series.data[index]? and not series.data[index+1]?
            return { enabled: true }
      else if chartStyle is 'heatmap' or (chartStyle is 'scatter' and series.data?)
        return { enabled: true }
      return { enabled: false }

    chartFormatterService
]
